<template>
	<v-app id="appContainer">
		<!-- Header -->
		<the-fixit-no-header :header-props="header" :useOldNavigation="false" :active-user="user" :use-axios="true"
			:new-release="(mainMenuHasPromotionItem() && !headerNavigationHasPromotionItem()) || (mainMenuHasPromotionItem() && $vuetify.breakpoint.smAndDown)"
			:support-membership="true" :loginDialogClickOutside="loginDialogAllowClickOutside" @setUser="setActiveUser" @notify="setNotification" @loginWithJwt="loginWithJwt"
			ref="fixitNoHeader">
			<template v-slot:logo>
				<img @click="goHome()" :src="$umbraco.images[$root.atTop ? 'logo' : 'alternativeLogo'].Src"
					:alt="$umbraco.images.logo.Alt" height="50%" style="object-fit: contain; cursor: pointer"
					loading="eager" />
			</template>
		</the-fixit-no-header>

		<!-- Main content -->
		<v-main :style="{ 'min-height': `calc(100vh - ${$root.headerHeight(true)}px)` }">
			<v-container fluid constrain v-if="breadcrumbs.length > 1" class="pt-0 pb-0 pt-sm-5 pb-sm-10">
				<!-- Breadcrumbs -->
				<v-breadcrumbs :items="breadcrumbs" class="d-none d-sm-inline-flex primary secondary--text" large dark>
					<template v-slot:divider>
						<span class="secondary--text">/</span>
					</template>
				</v-breadcrumbs>
			</v-container>
			<router-view />
		</v-main>

		<!-- Footer -->
		<main-footer />

		<!-- Alerts -->
		<v-snackbar v-model="snackbar.display" color="base" :timeout="snackbar.timeout" class="snackbar"
			:top="snackbar.top == 'top'" :bottom="snackbar.bottom == 'bottom'">
			<v-icon left v-if="['success', 'info', 'warning', 'error'].includes(snackbar.type)" :color="snackbar.type">
				{{ snackbar.type == 'success' ? 'check_circle' : snackbar.type }}
			</v-icon>
			{{ snackbar.text }}
			<v-btn text v-if="snackbar.closeButton" @click="snackbar.display = false">Lukk</v-btn>
		</v-snackbar>
		<the-fixit-no-snackbar :snackbar="notification" @removeSnackbar="closeNotification" />
	</v-app>
</template>

<script>
import MainFooter from '@/components/MainFooter';
import MainMenu from '@/components/MainMenu';
import MainMenuIcon from '@/components/MainMenuIcon';
import LoginDialog from '@/components/LoginDialog';
import { waitFor } from 'vue-wait';

import { getBreadcrumbs } from '@/router/helpers';
import { Snackbar } from '@/services/models';
import { User, Header, Notification } from '@fixit/fixit-no-header/src/models'; // @fixit/fixit-no-header

import { TheFixitNoHeader, TheFixitNoSnackbar } from '@fixit/fixit-no-header';


export default {
	name: 'App',
	components: { MainFooter, MainMenu, MainMenuIcon, LoginDialog, TheFixitNoHeader, TheFixitNoSnackbar },
	data() {
		return {
			atTop: true,
			menuDialogOpen: false,
			loginDialogOpen: false,
			loginDialogAllowClickOutside: true,
			overrideLoginOptions: null,
			snackbar: {
				display: false,
			},
			showBadge: false,
			snackbarState: new Notification(),
			authRoutes: ['mypage',
				'webshopChainShoppingCartClickAndCollect',
				'webshopChainCheckoutClickAndCollect',
				'webshopChainCheckoutClickAndCollectOrderPreview',
				'webshopChainCheckoutCompletedClickAndCollect'
			]
		};
	},
	computed: {
		breadcrumbs() {
			return getBreadcrumbs(this.$route.name);
		},
		header() {
			let header = new Header({
				height: this.$root.headerHeight(),
				elevation: 0,
				apiUrl: process.env.VUE_APP_FIXIT_CORE_API_URL,
				oauthUrl: process.env.VUE_APP_OAUTH_URL,
				fixitNoUrl: process.env.VUE_APP_FIXIT_NO_URL,
				items: this.$umbraco.navigation.b2cMenuNavigation.map((item) => {
					return {
						Caption: item.Caption,
						Id: item.Id,
						Link: item.Link,
						OpenInNewWindow: item.OpenInNewWindow,
						isInternal: item.IsInternal,
						Visible: true,
						Type: item.Type,
						Dialog: false,
						DialogVariable: false,
					};
				}),
				layout: 'portal',
				atTop: this.$root.atTop,
			});
			if (!this.$root.atTop) header.headerColors = ['#472449', '#472449'];
			return header;
		},
		user: {
			get() {
				return new User(this.$user);
			},
			set(user) {
				this.$user.assign(user);
			},
		},
		notification: {
			get() {
				return this.snackbarState;
			},
			set(snack) {
				this.snackbarState = snack;
			},
		},
	},
	methods: {
		async navigate(path) {
			await this.$router.push(`/${path}`).catch(() => { }); // add catch to handle NavigationDuplicated error exception in console
			this.menuDialogOpen = false;
			this.loginDialogOpen = false;
		},
		setNotification(snackbar) {
			this.notification = new Notification(snackbar);
		},
		closeNotification(snackbar) {
			this.notification = new Notification(snackbar);
		},
		goHome() {
			this.$router.replace('/');
		},

		setSnackbar(snackbar = new Snackbar()) {
			this.snackbar = Object.assign({}, this.snackbar, {
				...snackbar,
				display: true,
			});
		},
		setLoginDialogOpen(loginDialogOpen, overrideOptions) {
			// TODO: Add form data to prefill create profile
			this.loginDialogOpen = loginDialogOpen;
			this.overrideLoginOptions = overrideOptions;
			if (this.$refs.fixitNoHeader) this.$refs.fixitNoHeader.openDialog()
		},

		forceUpdate() {
			this.$forceUpdate();
		},
		headerNavigationHasPromotionItem() {
			const promoteMenuItemText = this.$umbraco.settings.promoteMenuItemContainingText;
			return this.$umbraco.settings.promoteMainMenu && this.$umbraco.navigation.b2CHeaderNavigation.filter((x) => x.Caption.toLowerCase().indexOf(promoteMenuItemText) != -1).length > 0;
		},
		mainMenuHasPromotionItem() {
			const promoteMenuItemText = this.$umbraco.settings.promoteMenuItemContainingText;
			return this.$umbraco.settings.promoteMainMenu && this.$umbraco.navigation.b2cMenuNavigation.filter((x) => x.Caption.toLowerCase().indexOf(promoteMenuItemText) != -1).length > 0;
		},
		showMenuItemPromotion(caption) {
			// TODO: Refactor into Umbraco helper
			const displayMenuBadge = this.$umbraco.settings.promoteMainMenu;
			const promoteMenuItemText = this.$umbraco.settings.promoteMenuItemContainingText;

			return promoteMenuItemText && caption.toLowerCase().indexOf(promoteMenuItemText) != -1 && displayMenuBadge;
		},
		setActiveUser(user) {
			if (user.onlineSluttKundeId > 0) {
				this.user = user;
			} else {
				this.user.onlineSluttKundeId > 0 ? this.logOut() : this.user = new User()
			}
		},
		async logOut() {
			this.loading++;
			waitFor(`loading user logout`, async function () {
				if (await this.$store.dispatch('user/logout')) {
					this.$user.assign(new User());
					setTimeout(() => {
						this.$forceUpdate();
						this.$eventBus.$emit('user-logged-out');
					}, 250);
					this.$store.dispatch('user/getLastVisitedSalons');
					this.dialog = false;

					// To prevent error (NavigationDuplicated) "https://github.com/vuejs/vue-router/issues/2872"
					// We use replace instead of push.
					let chainId = this.$route.params.chainId || this.$route.query.chainId;
					if (this.authRoutes.includes(this.$route.name) || this.$route.name.includes('mypage')) {
						this.$router.replace(chainId ? { name: 'webshopChain', params: { chainId } } : { name: 'frontpage' }).catch(() => { });
					}
				}

				// Logout failed.
				else {
					this.$eventBus.$emit('snackbar', {
						text: 'Utlogging feilet. Vennligst prøv på nytt.',
						type: 'error',
					});
				}
			}).apply(this);
			this.loading--;
		},
		async loginWithJwt() {
			await this.$store.dispatch('user/LoginByJwt').then((res) => {
				if (res) {
					this.$store.dispatch('user/getLastVisitedSalons');
					this.$eventBus.$emit('user-logged-in', this.$user);
				}
			});
		},
	},
	watch: {
		loginDialogOpen(value) {
			// Reset forms when dialog is closed.
			if (!value) {
				this.overrideLoginOptions = null;
			}
		},
		menuDialogOpen(value) {
			this.showBadge = !value;
		},
	},
	mounted() {
		setTimeout(() => {
			if (window.location.pathname === '/kjop-gavekort' && this.user.onlineSluttKundeId === 0) {
				if (this.$refs.fixitNoHeader) {
					window.location.href = process.env.VUE_APP_B2C_LOGIN_URL + '?externalReturnUrl=' + window.location.href
				}
			}
		}, 1000);
	},
	created() {
		this.$eventBus.$on('snackbar', this.setSnackbar);
		this.$eventBus.$on('force-update', this.forceUpdate);
		this.$eventBus.$on('login-dialog', this.setLoginDialogOpen);
		setTimeout(() => {
			this.showBadge = true;
		}, 1000);
	},
};
</script>

<style lang="scss">
.v-application.portal-layout {
	background-image: linear-gradient(var(--v-secondary-base) 10vh, var(--v-accent-base) 35vh, var(--v-tertiary-base) 100vh) !important;

	.v-application--wrap {
		&>.snackbar {
			.v-snack__content {
				justify-content: unset;
			}
		}
	}
}
</style>
